<template>
    <div class="tag-container align-items-end d-flex" :class="{ expired: isOfferExpired }">
        <p class="tag lowest-rates d-flex" v-if="isLowestRate == true">
            <span class="fa-stack fa-2x d-none d-md-flex">
                <i class="fas fa-circle fa-stack-2x"></i>

                <i class="fas fa-star fa-stack-1x"></i>
            </span>

            {{ $t('results.tags.lowestRate') }}
        </p>

        <p v-if="isAlternateAmount && !isAlternateAmountAndTerm" class="tag alternative d-flex">
            <span class="fa-stack fa-2x d-none d-md-flex">
                <i class="fas fa-circle fa-stack-2x"></i>

                <i :class="`${moneyIcon()} currency-sign fa-stack-1x fa-inverse`"></i>
            </span>

            {{ $t('results.tags.alternativeAmount') }}
        </p>

        <p v-if="isAlternateTerm && !isAlternateAmountAndTerm" class="tag alternative d-flex">
            <span class="fa-stack fa-2x d-none d-md-flex">
                <i class="fas fa-circle fa-stack-2x"></i>

                <i :class="`${moneyIcon()} currency-sign fa-stack-1x fa-inverse`"></i>
            </span>

            {{ $t('results.tags.alternativeTerm') }}
        </p>

        <p v-if="isAlternateAmountAndTerm" class="tag alternative d-flex">
            <span class="fa-stack fa-2x d-none d-md-flex">
                <i class="fas fa-circle fa-stack-2x"></i>

                <i :class="`${moneyIcon()} currency-sign fa-stack-1x fa-inverse`"></i>
            </span>

            {{ $t('results.tags.alternativeAmount&Term') }}
        </p>

        <p class="tag funding-speed d-flex" v-if="canShowFastFundingFlag">
            <span class="fa-stack fa-2x d-none d-md-flex">
                <i class="fas fa-clock fa-w-16 fa-stack-2x"></i>
            </span>

            {{ fundingSpeed }}
        </p>

        <p
            class="tag d-flex"
            v-if="formattedOfferType"
            v-tippy="tooltipOptions"
            :class="{ caveat: tooltipOptions.content }"
        >
            <i
                class="tag-icon fas d-none d-md-flex"
                :class="isLendindtree ? 'fa-bookmark' : 'fa-info-circle'"
                v-if="tooltipOptions.content"
            ></i
            >{{ formattedOfferType }}
        </p>

        <p
            class="tag d-flex"
            v-if="!isVervent && !isLendindtree"
            v-for="(productType, index) in formattedCreditCardProductTypes"
            :key="index"
            v-tippy="tooltipOptions"
            :class="{ caveat: tooltipOptions.content }"
        >
            <i class="tag-icon fas fa-info-circle d-none d-md-flex" v-if="tooltipOptions.content"></i>{{ productType }}
        </p>

        <p class="tag caveat d-flex" v-if="offer.caveat_description" v-tippy="customToolTipOptions">
            <i class="tag-icon fas d-md-flex" :class="isLendindtree ? 'fa-bookmark' : 'fa-info-circle'"></i>

            {{ offer.caveat_description }}
        </p>
    </div>
</template>

<script>
import { errorNotify } from '@js/utilities/bugsnag.js'
import { moneyIcon } from '@js/utilities/language.js'

export default {
    props: ['offer', 'loanAmount', 'loanTerm', 'isOfferExpired', 'fastFundingFlagStatus'],
    inject: ['lowestOffersRate', 'offerGroup'],
    data() {
        return {
            tooltipOptions: {
                content: null,
                trigger: 'click',
                arrow: true,
                animation: 'scale',
            },
            customToolTipOptions: {
                content: null,
                trigger: 'click',
                arrow: true,
                animation: 'scale',
            },
        }
    },
    created() {
        this.tooltipContentFill()
    },
    updated() {
        this.tooltipContentFill()
    },
    methods: {
        moneyIcon: moneyIcon,
        toolTip: function () {
            switch (this.offer.type) {
                case 'secured_loan':
                    return this.$t('results.offerBlocks.toolTipText.securedLoan')
                case 'guarantor_loan':
                    return this.$t('results.offerBlocks.toolTipText.guarantorLoan')
                case 'line_of_credit':
                    return this.$t('results.offerBlocks.toolTipText.lineOfCredit')
                default:
                    return null
            }
        },
        customToolTip: function () {
            return this.offer.caveat_tooltip ? this.offer.caveat_tooltip : null
        },
        tooltipContentFill: function () {
            this.tooltipOptions.content = this.toolTip()
            this.customToolTipOptions.content = this.customToolTip()
            this.hackToRemoveCaveat() //hack function call
        },
        hackToRemoveCaveat: function () {
            //more HACK comments
            if (this.offer.caveat_description) {
                if (this.offer.caveat_description.includes('This offer is a')) {
                    this.offer.caveat_description = null
                }
            }
        },
    },
    computed: {
        isLowestRate: function () {
            if (this.lowestOffersRate && this.lowestOffersRate.apr) {
                return this.lowestOffersRate.apr.min === this.offer.apr.min || false
            } else {
                return false
            }
        },
        isAlternateAmount: function () {
            return this.loanAmount != this.offer.loan_offer?.loan?.loan_amount && !this.offer.loan_offer?.credit_card
        },
        isAlternateTerm: function () {
            if (this.offer.loan_offer?.loan?.term) {
                return (
                    this.loanTerm != this.offer.loan_offer?.loan?.term &&
                    this.excludeTerritories('usa') &&
                    !this.offer.loan_offer?.credit_card
                )
            }
            return false
        },
        isAlternateAmountAndTerm: function () {
            return (
                this.isAlternateTerm &&
                this.isAlternateAmount &&
                this.excludeTerritories('usa') &&
                !this.offer.loan_offer?.credit_card
            )
        },
        formattedOfferType: function () {
            if (this.excludeTerritories('usa')) {
                switch (this.offer.type) {
                    case 'secured_loan':
                        return this.$t('results.offerBlocks.offerTypes.securedLoan')
                    case 'line_of_credit':
                        return this.$t('results.offerBlocks.offerTypes.lineOfCredit')
                }
            }

            switch (this.offer.type) {
                case 'car_finance':
                    return this.$t('results.offerBlocks.offerTypes.carFinance')
                case 'guarantor_loan':
                    return this.$t('results.offerBlocks.offerTypes.guarantorLoan')
                case 'personal_loan':
                    return this.$t('results.offerBlocks.offerTypes.personalLoan')
                case 'debt_solution':
                    return this.$t('results.offerBlocks.offerTypes.debtSolution')
                default:
                    return null
            }
        },
        creditCardProductTypes: function () {
            const productType = this.offer?.loan_offer?.credit_card?.product_type
            if (productType && productType.length > 0) {
                return this.offer.loan_offer.credit_card.product_type.split(',')
            }

            return this.offer?.type.includes('credit card only', 'credit_card') ? ['purchases'] : []
        },
        formattedCreditCardProductTypes: function () {
            const arr = []
            this.creditCardProductTypes.forEach(productType => {
                let translated = this.$t(`results.offerBlocks.creditCardProductTypes.${productType}`)

                if (productType === 'purchases' || productType === 'balance_transfer' || productType === 'rewards') {
                    translated = translated.replace('0% ', '')
                }

                // in case of missing translation for a new tag
                const translatedReplaced = translated.replace('results.offerBlocks.creditCardProductTypes.', '')
                if (translated !== translatedReplaced) {
                    errorNotify(
                        'Missing translation for possible new credit card product_type',
                        'error',
                        'Result Page',
                        { productType: productType },
                    )
                }

                arr.push(translatedReplaced)
            })

            return arr
        },
        isVervent: function () {
            return process.env.IS_VERVENT
        },
        isLendindtree: function () {
            return process.env.IS_LENDINDTREE
        },
        fundingSpeed: function () {
            return this.offer.lender.funding_speed
        },
        canShowFastFundingFlag: function () {
            return (
                this.fastFundingFlagStatus &&
                this.offer.lender.funding_speed &&
                this.offer.lender.funding_speed !== 'N/A'
            )
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.tag-container {
    flex-wrap: wrap;

    &.expired {
        opacity: 50%;
    }

    .tag {
        background-color: var(--standard-tag-background-color);
        border-radius: 4px;
        color: var(--standard-tag-font-color);
        font-size: rem(12px);
        font-weight: bold;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 4px 6px;

        &.lowest-rates {
            background-color: var(--lowest-rate-tag-background-color);
            color: var(--lowest-rate-tag-font-color);
        }

        &.alternative {
            background-color: var(--alternative-amount-tag-background-color);
            color: var(--alternative-amount-tag-font-color);
        }

        &.funding-speed {
            background-color: var(--funding-speed-tag-background-color);
            color: var(--funding-speed-tag-font-color);
        }

        &.caveat {
            cursor: pointer;
        }

        @media screen and (min-width: $bp-large) {
            padding: 8px;
        }

        .icon {
            margin-right: 5px;
            min-width: 14px;
            position: relative;
        }

        .star-circle {
            &:before {
                content: var(--url-star-circle);
                height: 100%;
                position: absolute;
                top: 2px;
                width: 100%;
            }
        }

        .fa-stack {
            font-size: rem(7px);
            margin: 2px 5px 0px 0px;
        }
    }

    .tag-icon {
        align-self: center;
        display: flex;
        font-size: rem(14px);
        margin-right: 5px;
    }

    .fa-star {
        color: var(--lowest-rate-tag-background-color);
    }

    .currency-sign {
        color: var(--alternative-amount-tag-background-color);
    }
}
</style>
